/**
 * Logger Utility
 * Centralized logging with configurable log levels
 */

import { LOG_LEVEL, CURRENT_LOG_LEVEL } from '../config/constants';

class Logger {
  private logLevel: LOG_LEVEL = CURRENT_LOG_LEVEL;

  setLogLevel(level: LOG_LEVEL): void {
    this.logLevel = level;
  }

  private shouldLog(level: LOG_LEVEL): boolean {
    const levels = [LOG_LEVEL.DEBUG, LOG_LEVEL.INFO, LOG_LEVEL.WARN, LOG_LEVEL.ERROR];
    return levels.indexOf(level) >= levels.indexOf(this.logLevel);
  }

  debug(message: string, data?: any): void {
    if (this.shouldLog(LOG_LEVEL.DEBUG)) {
      console.log(`🔍 [DEBUG] ${message}`, data || '');
    }
  }

  info(message: string, data?: any): void {
    if (this.shouldLog(LOG_LEVEL.INFO)) {
      console.log(`ℹ️ [INFO] ${message}`, data || '');
    }
  }

  warn(message: string, data?: any): void {
    if (this.shouldLog(LOG_LEVEL.WARN)) {
      console.warn(`⚠️ [WARN] ${message}`, data || '');
    }
  }

  error(message: string, error?: any): void {
    if (this.shouldLog(LOG_LEVEL.ERROR)) {
      console.error(`❌ [ERROR] ${message}`, error || '');
    }
  }

  success(message: string, data?: any): void {
    if (this.shouldLog(LOG_LEVEL.INFO)) {
      console.log(`✅ [SUCCESS] ${message}`, data || '');
    }
  }
}

export const logger = new Logger();
